import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedSearchBarComponent } from './shared-search-bar.component';
import { FormsModule } from '@angular/forms';

import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@NgModule({
  declarations: [
    SharedSearchBarComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    FGBSharedModule
  ],
  exports: [
    SharedSearchBarComponent
  ]
})
export class SharedSearchBarModule { }
